export default __webpack_public_path__ + "static/media/earthlogo.3df3715e.svg";